import React, { Component } from 'react';

class DotLoader extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div className={`dot-loader ${this.props.size || "medium"} ${this.props.variant || "light"}`}>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
            </div>
        );
    }
}

export default DotLoader;

